import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import CveRetencOptions from '../../support/catalogos/CveRetencOptions';

const RetencionBaseForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    let ruleDescRetenc = 'string';

    if (data.CveRetenc === '25') {
      ruleDescRetenc = 'required';
    }

    return {
      CveRetenc: [
        'required',
        'string',
        'in:01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28',
      ],
      FolioInt: ['string', 'min:1', 'max:20'],
      DescRetenc: [ruleDescRetenc, 'string', 'min:1', 'max:100'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(event, {
      step: 'base',
      name: 'isValidRetencionBase',
      isValid: validator.passes(),
    });
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <>
      <Row>
        <Col>
          <FormControl
            type="select"
            label="Clave retención"
            name="CveRetenc"
            placeholder=""
            help=""
            rules={rules.CveRetenc}
            value={data.CveRetenc}
            options={CveRetencOptions}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FormControl
            type="text"
            label="Folio Interno"
            name="FolioInt"
            placeholder=""
            help=""
            rules={rules.FolioInt}
            value={data.FolioInt}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col
          sm
          md={12}
        >
          <FormControl
            as="textarea"
            label="Descripción"
            name="DescRetenc"
            placeholder=""
            help=""
            minLength="1"
            maxLength="100"
            rules={rules.DescRetenc}
            value={data.DescRetenc}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </>
  );
};

export default RetencionBaseForm;
